import React from "react";
import PropTypes from "prop-types";
import { IconGreenCheck } from "../common/Icons/GreenCheck";

const Notice = ({ message, onLinkClick }) => {
    return (
        <div id="warnNotice" className="alert success-alert-enquiry mb-20" data-testid="alert-email-success">
            <span className='alert-icon'>
                <IconGreenCheck className="icon-check" width='18' height='18' />
            </span>
            <div>
                <p className="alert-text">
                    {message}
                </p>
                <button className="alert-link link-primary text-semi-bold" onClick={onLinkClick}>
                    Click here to re-submit the form.
                </button>
            </div>
        </div>
    );
};

Notice.propTypes = {
    message: PropTypes.string.isRequired,
    onLinkClick: PropTypes.func.isRequired
};

export default Notice;